/**
 * Converts a string price (e.g., "$13.25 / serving") or a raw number
 * into a clean floating-point number
 */
export const parsePricePerRecipe = (priceVal: string | number): number => {
  if (typeof priceVal === 'number') return priceVal;
  if (!priceVal) return 0;
  const cleaned = priceVal.replace(/[^0-9.]/g, '');
  return parseFloat(cleaned) || 0;
};
